export enum QuoteStatus {
  LOADING = 'loading',
  ERROR = 'error',
  READY = 'ready',
  NO_QUOTE = 'no_quote',
}
